import { render } from "./HeaderUI.vue?vue&type=template&id=166bcff8&scoped=true"
import script from "./HeaderUI.vue?vue&type=script&lang=js"
export * from "./HeaderUI.vue?vue&type=script&lang=js"

import "./HeaderUI.vue?vue&type=style&index=0&id=166bcff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166bcff8"]])

export default __exports__